import { createElement, FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { ComponentFormValues } from '@components/EntityDrawers/drawers/Component/form';
import Advanced from '@components/EntityDrawers/drawers/Component/tabs/Advanced';
import Standard from '@components/EntityDrawers/drawers/Component/tabs/Standard';
import { DrawerContentProps } from '@components/EntityDrawers/hocs/withDrawer';
import { TimeLineDateError } from '@constants/validation';
import useTwoDatesValidation from '@hooks/useTwoDatesValidation';

export const ComponentContent: FC<DrawerContentProps> = ({ tab }) => {
  const form = useFormContext<ComponentFormValues>();

  useTwoDatesValidation({
    form,
    startKeyName: 'timelineStartDate',
    endKeyName: 'timelineEndDate',
    error: () => TimeLineDateError,
  });

  return createElement([Standard, Advanced][tab ?? 0]);
};
